import React from 'react'
import HomeLogo from './HomeLogo'
import SearchBox from './SearchBox'

function HomePage() {
    return (
        <div className="App__HomePage section__padding">
            <HomeLogo />
            <SearchBox />
        </div>
    )
}

export default HomePage
